import { ChipProps } from '@thirdspacelearning/library';

export const loActiveChipOptions: {
    id: string | number;
    label: string;
    color: ChipProps['color'];
}[] = [
    { id: 'active', label: 'Active', color: 'success' },
    { id: 'inactive', label: 'Inactive', color: 'warning' },
];
